import React, { useState } from "react";
import Modal from "../../../../components/ui/Modal";
import Input from "../../../../components/ui/Input";
import Button from "../../../../components/ui/Button";
import { mockCreator } from "../../../../data/mockData";

const CreateGroupModal = ({ isOpen, onClose, onSave }) => {
  const [groupName, setGroupName] = useState("");
  const [selectedUserIds, setSelectedUserIds] = useState([]);

  const handleUserSelect = (userId) => {
    setSelectedUserIds((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const handleSaveClick = () => {
    if (!groupName || selectedUserIds.length === 0) return;

    onSave({ groupName, memberIds: selectedUserIds });
    onClose();
  };

  // Reset state when modal closes
  const handleClose = () => {
    setGroupName("");
    setSelectedUserIds([]);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Create New Audience Group"
    >
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">
            Group Name
          </label>
          <Input
            placeholder="e.g., VIP Merch Buyers"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
          />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">
            Select Members
          </label>
          <div className="mt-2 max-h-60 overflow-y-auto border border-slate-200 rounded-lg p-2 space-y-2">
            {mockCreator.audienceList.map((user) => (
              <div key={user.id} className="relative flex items-start">
                <div className="flex h-5 items-center">
                  <input
                    id={`user-${user.id}`}
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                    checked={selectedUserIds.includes(user.id)}
                    onChange={() => handleUserSelect(user.id)}
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label
                    htmlFor={`user-${user.id}`}
                    className="font-medium text-slate-700"
                  >
                    @{user.username}
                  </label>
                  <p className="text-slate-500">{user.status}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-end pt-4 space-x-3">
          <Button variant="ghost" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            Save Group
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateGroupModal;
